<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">任务管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>任务类型：</label>
          <el-select v-model="type" placeholder="Select" style="width: 8em">
            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" :loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <!--          <el-button type="primary" @click="editTaskDialog(-1)">新建标签</el-button>-->
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
        >
          <el-table-column property="id" label="任务编号" v-if="checkColList.indexOf('任务编号') > -1" width="90"></el-table-column>
          <el-table-column property="name" label="任务名" v-if="checkColList.indexOf('任务名') > -1" ></el-table-column>
          <el-table-column property="description" label="任务描述" v-if="checkColList.indexOf('任务描述') > -1" ></el-table-column>
<!--          <el-table-column property="description" label="任务类型" v-if="checkColList.indexOf('任务类型') > -1" ></el-table-column>-->
          <el-table-column property="" label="任务类型" v-if="checkColList.indexOf('任务类型') > -1" width="100">
            <template #default="scope">
              {{scope.row.type == 1?'每日任务':scope.row.type == 2?'单次任务':''}}
            </template>
          </el-table-column>
          <el-table-column property="" label="每日可完成次数" v-if="checkColList.indexOf('每日可完成次数') > -1" width="130">
            <template #default="scope">
              <span>{{scope.row.everydayNum == 0 ? '--' : scope.row.everydayNum}}</span>
            </template>
          </el-table-column>
          <el-table-column property="conditionNum" label="条件参数" v-if="checkColList.indexOf('条件参数') > -1" width="100">
            <template #default="scope">
              <span>{{scope.row.edit == 0 ? '--' : scope.row.conditionNum}}</span>
            </template>
          </el-table-column>
          <el-table-column property="rewardNum" label="奖励金币数量" v-if="checkColList.indexOf('奖励金币数量') > -1" width="120">
            <template #default="scope">
              <span>{{scope.row.rewardGoldNum}}金币</span>
            </template>
          </el-table-column>
          <el-table-column property="showOrder" label="排序" v-if="checkColList.indexOf('排序') > -1" width="90"></el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1" width="90">
            <template #default="scope">
              <span>{{scope.row.state == 1?'开启中':scope.row.state == 2?'已下架':''}}</span>
            </template>
          </el-table-column>
          <el-table-column property="" label="展示版本" v-if="checkColList.indexOf('展示版本') > -1" width="90">
            <template #default="scope">
              <span>{{scope.row.versionState == 0?'全部':scope.row.versionState == 1?'旧版':scope.row.versionState == 2?'新版':''}}</span>
            </template>
          </el-table-column>
          <el-table-column property="" label="性别" v-if="checkColList.indexOf('性别') > -1" width="90">
            <template #default="scope">
              <span>{{scope.row.sex == 1?'男':scope.row.sex == 2?'女':'不限'}}</span>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1" width="120">
            <template #default="scope">
              <el-space wrap>
                <el-button size="small" @click="editTaskDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import BtnGroup from '../../components/BtnGroup'
import { getTaskCenterPageList } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from "@/assets/js/dialog";
import TaskManageDialog from "./components/TaskManageDialog";

export default {
  name: "TaskManage",
  components: { BtnGroup },
  data() {
    return {

      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: -1,

      typeArray: [
        {label: '不限', value: -1},
        {label: '每日任务', value: 1},
        {label: '单次任务', value: 2},
      ],
      type: -1,

      stateArray: [
        {label: '不限', value: -1},
        {label: '开启中', value: 1},
        {label: '已下架', value: 2},
      ],
      state: -1,


      //刷新组
      colList: ['任务编号', '任务名', '任务描述', '任务类型', '每日可完成次数', '条件参数', '奖励金币数量', '排序', '状态', '展示版本', '性别', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

    }
  },
  methods: {
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.sex = -1;
      this.type = -1;
      this.state = -1;
      this.getPage(true);
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['type'] = this.type;
      param['state'] = this.state;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getTaskCenterPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editTaskDialog(idx, row) {
      let _title = '';
      let taskForm = {}
      if (idx > -1) {
        _title = '编辑任务'
        taskForm = Object.assign({}, row);
      }else {
        _title = '新建任务'
      }
      Dialog.open({
        title: _title,
        component: TaskManageDialog,
        data: {
          taskForm: taskForm,
          ids: idx,
          width: '500px'
        },
        confirm: (result) => {
          row.name = result.name
          row.description = result.description
          row.rewardGoldNum = result.rewardGoldNum
          row.everydayNum = result.everydayNum
          row.showOrder = result.showOrder
          row.conditionNum = result.conditionNum
          row.toTop = result.toTop
          row.state = result.state
          row.versionState = result.versionState
        }
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
